import { StatusIndicator } from "@nulogy/components";
import React from "react";

export default function LineStatusIndicator({ value, label }) {
  const booleanValue = value !== undefined ? value : label === "Active";

  return (
    <>
      {booleanValue ? (
        <StatusIndicator type="success">Active</StatusIndicator>
      ) : (
        <StatusIndicator>Inactive</StatusIndicator>
      )}
    </>
  );
}
